import SelectWarehouseSecuritySettingsPopup from './popups/SelectWarehouseSecuritySettingsPopup'
import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import CodePreview from './popups/CodePreview'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'
import PinPopup from './popups/PinPopup'

const AccessSettings = () => {
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))
  const isAnySecureOptionSelected = (
    warehouse?.['2fa_access']?.biometricsSecured ||
    warehouse?.['2fa_access']?.applicationPinSecured ||
    warehouse?.['2fa_access']?.customPinSecured
  )

  const { t } = useTranslation('warehouse')
  const { popup, openPopup } = usePopupState<{ type: 'pin' | 'codePreview' | 'warehouseAccessType' }>()

  return (
    <>
      {popup && <div>
        {popup?.type === 'pin' && <PinPopup
          selected={warehouse?.['2fa_access']?.customPinSecured}
        />}
        {popup?.type === 'codePreview' && <CodePreview
          contractId={warehouse.contractId}
        />}
        {popup?.type === 'warehouseAccessType' && <SelectWarehouseSecuritySettingsPopup
          showPinPopup={() => {
            openPopup({ type: 'pin' })
          }}
        />}
      </div>}

      {/* <p>{t('securitySettings')}</p> */}
      <div className='menu__additionalAccess'>
        <hr />
        <div
          className='menu__additionalAccess__item'
          onClick={() => {
            openPopup({ type: 'warehouseAccessType' })
          }}>
          <div className='menu__additionalAccess__item__icon'>
            <i className={`icon icon--padlock-${isAnySecureOptionSelected ? 'closed' : 'open'} s24`} />
          </div>
          <div className='menu__additionalAccess__item__desc'>
            <div>{t('accessSecurity')}</div>
            <div>
              {warehouse?.['2fa_access']?.biometricsSecured
                ? t('biometricAndAppPin')
                : warehouse?.['2fa_access']?.customPinSecured
                  ? t('appPin')
                  : warehouse?.['2fa_access']?.applicationPinSecured
                    ? t('storagePin')
                    : t('noSecurity')}
            </div>
          </div>
          <i className='icon icon--forward s24' />
        </div>

        {warehouse.hasCodes && warehouse.hasAccess && <>
          <hr />
          <div
            className='menu__additionalAccess__item'
            onClick={() => {
              openPopup({ type: 'codePreview' })
            }}>
            <div className='menu__additionalAccess__item__icon'>
              <i className='icon icon--pin s24' />
            </div>
            <div className='menu__additionalAccess__item__desc'>
              <div>{t('accessCode')}</div>
              <div>{t('accessCodeDescription')}</div>
            </div>
            <i className='icon icon--forward s24' />
          </div>
        </>}
      </div>
    </>
  )
}

export default AccessSettings